import React from 'react';
import {useIntl} from 'react-intl';
import {PhoneHQConfirmDialog} from 'ch3-ui-lib';

interface LeaveConversationDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => Promise<void>;
    isDirect?: boolean;
}

export const LeaveConversationDialog: React.FC<LeaveConversationDialogProps> = ({
    open,
    onOpenChange,
    onConfirm,
    isDirect = false
}) => {
    const intl = useIntl();

    const handleLeave = () => {
        onOpenChange(false);
        void onConfirm().catch((error) => {
            console.error('Failed to leave room:', error);
        });
    };

    const title = isDirect
        ? intl.formatMessage({id: 'chat.leave-dm.title', defaultMessage: 'Leave chat?'})
        : intl.formatMessage({id: 'chat.leave-group.title', defaultMessage: 'Are you sure you want to leave the group?'});
    const message = isDirect
        ? intl.formatMessage({id: 'chat.leave-dm.message', defaultMessage: 'You\'ll no longer see this conversation. You can only rejoin if the other person messages you again.'})
        : intl.formatMessage({id: 'chat.leave-group.message', defaultMessage: 'If you leave, you\'ll no longer be able to access it. To regain access, you\'ll need to be invited by a project member.'});
    const confirmLabel = isDirect
        ? intl.formatMessage({id: 'chat.leave-dm.confirm', defaultMessage: 'Leave chat'})
        : intl.formatMessage({id: 'chat.leave-group.confirm', defaultMessage: 'Yes, Leave'});

    return (
        <PhoneHQConfirmDialog
            open={open}
            onOpenChange={onOpenChange}
            title={title}
            cancelLabel="Cancel"
            confirmLabel={confirmLabel}
            tone="danger"
            onConfirm={handleLeave}
            confirmTestId="chat.leave.confirm-btn"
        >
            {message}
        </PhoneHQConfirmDialog>
    );
};
